export const emptyValidation = (fieldName, fieldValue) => {
  if (fieldValue === undefined || fieldValue === '') {
    return `${fieldName} is required`;
  }
  return null;
};

export const numberValidation = (fieldName, fieldValue) => {
  if (fieldValue === '') {
    return `${fieldName} is required`;
  }
  if (! /^[0-9]+$/.test(fieldValue)) {
    return 'Please enter a valid number';
  }
  return null;
};

export const decimalValidation = (fieldName, fieldValue) => {
  if (fieldValue === '') {
    return `${fieldName} is required`;
  }
  if (! /^[0-9]\d*(\.\d+)?$/.test(fieldValue)) {
    return 'Please enter a valid decimal';
  }
  return null;
};

export const quantitiesValidation = (parameters) => {
  if (parameters.quantities
      && parameters.quantities[0] === ''
      && parameters.quantities[1] === ''
      && parameters.quantities[2] === ''
      && parameters.quantities[3] === '') {
    return 'fill at least one quantity';
  }

  for (let i in parameters.quantities) {
    if (parameters.quantities[i] !== '' && ! /^[0-9]+$/.test(parameters.quantities[i])) {
      return 'Invalid characters';
    }
  }

  // Check the Fabrication Case with need my boards in arrays
  if (parameters.has_array === '1') {
    const array_up = parseInt(parameters.array_up);
    if (array_up) {
      for (let i in parameters.quantities) {
        var quantity = parseInt(parameters.quantities[i]);
        if (parameters.quantities[i] % array_up !== 0) {
          return 'All quantities must be multiple of Array Up.';
        }
      }
    } else {
      // The case there are not array up specified
      return 'All quantities must be multiple of Array Up.';
    }
  }

  return null
}

export const placementsValidation = (parameters) => {
  if (parameters.smt === ''
      && parameters.thru_hole === ''
      && parameters.bga === ''
      && parameters.qfn === '') {
    return 'At least one placement must be filled';
  }

  if (parameters.smt !== '' && ! /^(0|[1-9]\d*)$/.test(parameters.smt)) {
    return 'Invalid characters';
  }
  if (parameters.thru_hole !== '' && ! /^(0|[1-9]\d*)$/.test(parameters.thru_hole)) {
    return 'Invalid characters';
  }
  if (parameters.bga !== '' && ! /^(0|[1-9]\d*)$/.test(parameters.bga)) {
    return 'Invalid characters';
  }
  if (parameters.qfn !== '' && ! /^(0|[1-9]\d*)$/.test(parameters.qfn)) {
    return 'Invalid characters';
  }

  return null;
};

export const rangeValidation = (fieldName, fieldValue, minValue, maxValue) => {
  if (fieldValue === '') {
    return `${fieldName} is required`;
  }

  if (! /^[0-9]\d*(\.\d+)?$/.test(fieldValue)) {
    return 'Invalid characters';
  }

  var intValue = parseFloat(fieldValue);
  if (intValue > maxValue) {
    return `Max ${fieldName} is ${maxValue}`;
  }
  if (intValue < minValue) {
    return `Min ${fieldName} is ${minValue}`;
  }

  return null;
};

export const panelizedValidation = (parameters) => {
  if (parameters.has_array === '1') {
    if (parameters.is_panelized === '') {
      return 'Please select if your boards are panelized or not.';
    }
  }
  return null;
}

export const hasArrayValidation = (fieldName, key, parameters) => {
  if (parameters.is_panelized === '1') {
    var validate_is_panelized = ['array_x', 'array_y', 'array_up'];
    if (validate_is_panelized.includes(key)) {
      if (key == 'array_up') {
        return numberValidation(fieldName, parameters[key]);
      }
      return decimalValidation(fieldName, parameters[key]);
    }
    return null;
  }

  if (parameters.is_panelized === '0') {
    var validate_is_not_panelized = ['array_x_qty', 'array_y_qty', 'array_spacing_x', 'array_spacing_y'];
    if (validate_is_not_panelized.includes(key)) {
      if (key === 'array_x_qty' || key === 'array_y_qty') {
        return numberValidation(fieldName, parameters[key]);
      }
      return emptyValidation(fieldName, parameters[key]);
    }
    return null;
  }
  return null;
}

export const railWidthValidation = (parameters) => {
  if (parameters.has_array === '1' && parameters.is_panelized === '0') {
    if (parameters.rails_sides === undefined) return 'Select an option to Rails';

    if (parameters.rails_sides !== 'no_sides') {
      // Check there is a value for Rail Width
      if (parameters.rails_width === undefined || parameters.rails_width === '') {
        return 'Select a value for Rail Width';
      }
    }
  }

  return null;
}

export const bomParametersValidation = (parameters) => {
  var bom_parameters = parameters.bom_parameters;
  var cont_bom_parameters = 0;
  var cont_mpn = 0;
  var cont_qty = 0;
  for (let i = 0; i < bom_parameters.length; i++) {
    if (bom_parameters[i] == 'qty_per_board'|| bom_parameters[i] == 'reference_designator') {
      cont_bom_parameters ++;
      cont_qty ++;
    }
    if(bom_parameters[i] == 'mpn' || bom_parameters[i] == 'vendor_part' ){
      cont_bom_parameters ++;
      cont_mpn ++;
    }
  }

  if (cont_bom_parameters < 2) {
    return 'Please identify the columns that correspond to Ref. Designator and MGF Part #';
  }
  if (cont_mpn != 1) {
    return 'Please identify the columns that correspond to MGF Part #. Just one column could be specify one Bom Field'
  }

  if (cont_qty > 2) {
    return 'Please identify the columns that correspond to Ref. Designator or Qty per board. Just one column could be specify one Bom Field'
  }

  return null;
}

/* "Please take actions about all the parts into Bom File" */
export const bomPartsValidation = () => null

export const partNumberValidation = (fieldName, fieldValue) => {
  if (fieldValue === '' || fieldValue.toString().trim() === '') return `${fieldName} is required`;

  if (fieldValue.length < 3) return 'Please enter at least 3 characters.';

  return null;
};

export const revisionValidation = (fieldName, fieldValue) => {
  if (fieldValue === undefined || fieldValue.toString().trim() === '') return `${fieldName} is required`;

  return null;
};

export const zipFileValidation = (fieldName, fieldValue) => {
  if (fieldValue === undefined || fieldValue.toString().trim() === '') return `${fieldName} is required`;

  return null;
};
